import { SvgIcon } from "@mui/material";
import React from "react";

const AnalyticsIcon = ({ fill = "currentColor" }) => {
  return (
    <SvgIcon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2V18C1.25 18.4142 1.58579 18.75 2 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V2C18.75 1.58579 18.4142 1.25 18 1.25H2ZM2.75 2.75V17.25H17.25V2.75H2.75Z"
          fill={fill}
        />
        <rect x="4" y="12.25" width="2.1" height="3.5" rx="0.55" fill={fill} />
        <rect x="8.05" y="9.25" width="2.1" height="6.5" rx="0.55" fill={fill} />
        <rect x="12.1" y="6" width="2.1" height="9.75" rx="0.55" fill={fill} />
        <path
          d="M4.7 7.9C4.7 7.5134 5.0134 7.2 5.4 7.2H6.63076C7.01735 7.2 7.33076 7.5134 7.33076 7.9C7.33076 8.2866 7.01735 8.6 6.63076 8.6H6.53141L8.43633 10.2428L12.4777 5.52842C12.6035 5.38167 12.7849 5.29447 12.978 5.28792C13.1712 5.28136 13.358 5.35609 13.4935 5.494L15.2166 7.24691V6.9C15.2166 6.5134 15.53 6.2 15.9166 6.2C16.3032 6.2 16.6166 6.5134 16.6166 6.9V8.95C16.6166 9.3366 16.3032 9.65 15.9166 9.65H13.8666C13.48 9.65 13.1666 9.3366 13.1666 8.95C13.1666 8.5634 13.48 8.25 13.8666 8.25H14.2465L13.0338 7.01609L8.99608 11.7267C8.87376 11.8694 8.69796 11.956 8.51076 11.9666C8.32356 11.9772 8.13905 11.9109 8.00146 11.783L5.46218 9.59315V9.7C5.46218 10.0866 5.14878 10.4 4.76218 10.4C4.37558 10.4 4.06218 10.0866 4.06218 9.7V7.9H4.7Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  );
};

export default AnalyticsIcon;
